import React,{useRef} from 'react'
import { auth } from '../firebase';
import './SignupScreen.css';
function SignupScreen() {
  const emailRef = useRef(null)
  const passwordRef = useRef(null)
   
  const register=(e)=>{
    e.preventDefault();
    auth
      .createUserWithEmailAndPassword(
        emailRef.current.value,
        passwordRef.current.value
      )
      .then((authUser)=>{
        console.log(authUser)
      })
      .catch((error)=>{
        alert(error.message)
    })
  }
  const signIn=(e)=>{
    e.preventDefault();

    auth.signInWithEmailAndPassword(
        emailRef.current.value,
        passwordRef.current.value
    ).then((authUser)=>{
      console.log(authUser);
    })
    .catch((error)=>alert(error.message))
  }
  return (
    <div className='signupScreen'>
        <form>
            <h1>Sign In</h1>
            <input ref={emailRef} placeholder='Email' type="email"/>
            <input ref={passwordRef} placeholder='Password' type="password"/>
            <button type="submit" onClick={signIn}>Sign In</button>
            <h4 className='signUp_link'><span className='signupScreen_gray'>New to Netflix? </span> <span className='signUpScreen_link' onClick={register}>Sign up now.</span></h4>
        </form>
    </div>
  )
}

export default SignupScreen